import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { GlobalMessage } from '../../types';

const initialState: GlobalMessage = {
  message: '',
  type: 'info',
  visible: false,
};

const globalMessageSlice = createSlice({
  name: 'globalMessage',
  initialState,
  reducers: {
    showGlobalMessage: (state, action: PayloadAction<{ message: string; type: 'success' | 'danger' | 'warning' | 'info' }>) => {
      state.message = action.payload.message;
      state.type = action.payload.type;
      state.visible = true;
    },
    hideGlobalMessage: (state) => {
      state.visible = false;
    },
  },
});

export const { showGlobalMessage, hideGlobalMessage } = globalMessageSlice.actions;
export default globalMessageSlice.reducer; 